<script setup lang="ts">
import AiSymbolFilled from '@/assets/svg/copilot-bubble.svg?component';
import EnrichmentTraceCloseButton from '@/components/Common/EnrichmentTraceCloseButton.vue';

defineProps<{
  subline: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();
</script>

<template>
  <header
    class="-mx-4 -mt-3 mb-3 flex items-center gap-2.5 rounded-t-xl border-b border-highlight-100 bg-enrichment-header px-4 pb-2.5 pt-[11px]"
  >
    <span
      class="flex h-[30px] w-[30px] shrink-0 items-center justify-center drop-shadow-1"
      aria-hidden="true"
      data-test-id="enrichment-trace-ai-icon"
    >
      <AiSymbolFilled class="h-[30px] w-[30px]" viewBox="0 0 20 20" />
    </span>

    <span class="min-w-0 flex-1">
      <span class="block text-sm font-bold leading-4 text-shade-880">Freshness check</span>
      <span class="mt-0.5 block truncate text-[11.5px] leading-4 text-shade-800">
        {{ subline }}
      </span>
    </span>

    <slot name="badge" />

    <EnrichmentTraceCloseButton label="Close freshness check" @close="emit('close')" />
  </header>
</template>
